var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgError = function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.25 18a7.75 7.75 0 1 1 0-15.5 7.75 7.75 0 0 1 0 15.5m0-1.5a6.25 6.25 0 1 0 0-12.5 6.25 6.25 0 0 0 0 12.5m0-5.001a.75.75 0 0 1-.75-.749v-4a.75.75 0 0 1 1.5 0v4a.75.75 0 0 1-.75.749m0 2.69a.75.75 0 0 1-.615-.323.75.75 0 0 1 .003-1.233.747.747 0 0 1 1.227.003.748.748 0 0 1 0 1.23.75.75 0 0 1-.615.322"
  })));
};
export default SvgError;